import React from 'react'
import { T } from '@transifex/react'

import { createCompanyRoutesMap } from './company'
import { createCompanyCrmPricingRoutesMap } from './company-crm-pricing'
import { createHaulerModuleRoutesMap } from './hauler'
import { createProjectRouteMap } from './project'
import { createProjectsDetailView } from './projects'
import { createRouteMigrationRoutesMap } from './route-migration'
import { pathJoin } from '../../../utils'

export const createSettingsPageRouteMap = (prefix: string) => ({
  'company/:id': (id = ':id') =>
    pathJoin(prefix)('company')(id).chainMapAuto(createCompanyRoutesMap, {
      title: <T _str="Settings" />,
      breadCrumbTitle: <T _str="Settings" />,
    }),
  'project/:id': (id = '') =>
    pathJoin(prefix)('project')(id).chainMapAuto(createProjectRouteMap, {
      title: <T _str="Project Details" />,
      breadCrumbTitle: <T _str="Project Details" />,
    }),
  projects: pathJoin(prefix)('projects').chainMapAuto(
    createProjectsDetailView,
    {
      title: <T _str="All Projects" />,
      breadCrumbTitle: <T _str="All Projects" />,
    }
  ),
  'company-crm-pricing': pathJoin(prefix)('company-crm-pricing').chainMapAuto(
    createCompanyCrmPricingRoutesMap,
    {
      title: <T _str="CRM Pricing" />,
      breadCrumbTitle: <T _str="CRM Pricing" />,
    }
  ),
  // "Contractors" is the user-facing name (2026-07-24 design call, matching
  // the renamed sidebar entry); the `hauler` key/URL stays for compatibility.
  hauler: pathJoin(prefix)('hauler').chainMapAuto(createHaulerModuleRoutesMap, {
    title: <T _str="Contractors" />,
    breadCrumbTitle: <T _str="Contractors" />,
  }),
  // PRODUCT-378: the route-migration lifecycle (Import · Improve · Go
  // live) is a Settings page now. Like `hauler`, it is NOT scoped under
  // `company/:id`: the Route Studio pages always show the viewer's own
  // company, so a company id in the URL would be a lie for staff.
  'route-migration': pathJoin(prefix)('route-migration').chainMapAuto(
    createRouteMigrationRoutesMap,
    {
      title: <T _str="Route Migration" />,
      breadCrumbTitle: <T _str="Route Migration" />,
    }
  ),
})
